import React from "react";
import { ExternalLink, FileSignature } from "lucide-react";

const EMPLOYEE_MANUAL_SIGNING_URL =
  "https://na4.documents.adobe.com/public/esignWidget?wid=CBFCIBAA3AAABLblqZhC3WM3iBvMP_cpicO0_dysfgRc-7Vgx-7Vxh6W4TyNncAlkLExPEY3zWMtGSWB-znc*";

const EmployeeManual = () => {
  return (
    <div className="min-h-screen bg-green-50 py-10">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="mb-6 flex flex-col gap-4 rounded-lg bg-white p-6 shadow-md md:flex-row md:items-center md:justify-between">
          <div className="flex items-start gap-4">
            <div className="rounded-full bg-orange-100 p-3">
              <FileSignature className="h-7 w-7 text-green-700" />
            </div>
            <div>
              <h1 className="text-3xl font-bold text-green-800">
                Employee Manual Acknowledgment
              </h1>
              <p className="mt-2 max-w-3xl text-gray-600">
                Review and sign the SBG employee manual through Adobe Acrobat Sign.
                After completion, Adobe will send a signed copy for your records.
              </p>
            </div>
          </div>

          <a
            href={EMPLOYEE_MANUAL_SIGNING_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 rounded-md bg-green-700 px-5 py-3 font-semibold text-white transition-colors hover:bg-green-800"
          >
            Open in Adobe
            <ExternalLink className="h-5 w-5" />
          </a>
        </div>

        <div className="overflow-hidden rounded-lg bg-white shadow-md">
          <iframe
            title="SBG Employee Manual Adobe Sign"
            src={EMPLOYEE_MANUAL_SIGNING_URL}
            className="h-[78vh] w-full border-0"
          />
        </div>
      </div>
    </div>
  );
};

export default EmployeeManual;
